function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { formatLabel, formatValue } from './lib';
import { FormatMetric } from "../";

class AnalyticsTableHead extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getClassName", () => {
      return "admin-analytics-table__head";
    });

    _defineProperty(this, "onSort", (by, order) => {
      if (this.props.onSort) {
        this.props.onSort(by, order);
      }
    });

    _defineProperty(this, "renderMetricHeader", (metric, index) => {
      const _this$props = this.props,
            sortBy = _this$props.sortBy,
            sortOrder = _this$props.sortOrder,
            tdStyle = _this$props.tdStyle,
            themeStyle = _this$props.themeStyle;
      const name = metric.name,
            type = metric.type;
      let selected, order, style;

      if (sortBy === name) {
        selected = true;
        style = _extends({}, tdStyle, {}, themeStyle);

        if (sortOrder === "ascending" || sortOrder === "asc") {
          order = "desc";
        } else {
          order = "asc";
        }
      } else {
        order = "desc";
        style = tdStyle;
      }

      return React.createElement("th", {
        className: "admin-analytics-table__label",
        "aria-selected": selected,
        style: style,
        key: index,
        onClick: () => this.onSort(name, order)
      }, React.createElement("b", null, React.createElement(FormatMetric, {
        name: name
      })), React.createElement("i", {
        "data-sort": sortOrder
      }));
    });

    _defineProperty(this, "renderMetricTotal", (metric, index) => {
      const _this$props2 = this.props,
            sortBy = _this$props2.sortBy,
            sortOrder = _this$props2.sortOrder,
            tdStyle = _this$props2.tdStyle,
            totals = _this$props2.totals;
      const name = metric.name,
            type = metric.type;
      const total = parseInt(totals[index]);
      let selected;

      if (sortBy === name) {
        selected = true;
      }

      let summary;

      if (type === "INTEGER") {
        summary = "% av total";
      } else {
        summary = "% ift gj. snitt";
      }

      return React.createElement("td", {
        className: "admin-analytics-table__total",
        style: tdStyle,
        "aria-selected": selected,
        key: index
      }, React.createElement("b", null, React.createElement(FormatMetric, _extends({}, metric, {
        value: total
      }))), React.createElement("i", null, summary));
    });

    _defineProperty(this, "renderDimension", (dimension, index) => {});
  }

  render() {
    const _this$props3 = this.props,
          thStyle = _this$props3.thStyle,
          metricHeaders = _this$props3.metricHeaders,
          dimensions = _this$props3.dimensions;
    const className = this.getClassName();
    return React.createElement("thead", {
      className: className
    }, React.createElement("tr", null, React.createElement("th", {
      style: thStyle
    }), metricHeaders.map(this.renderMetricHeader)), React.createElement("tr", null, React.createElement("th", {
      style: thStyle
    }), metricHeaders.map(this.renderMetricTotal)));
  }

}

export default AnalyticsTableHead;